import { useMutation } from '@tanstack/react-query';
import useSlingApi from '@sdk/api/useSlingApi';
import { UpdateMessagePayload } from '@sdk/messages/types/apiTypes';

import { useConversationQueryCache } from '@web/conversations/hooks/useConversationQueryCache';

import { useConversationMappers } from './useConversationMappers';

export const useUpdateMessage = () => {
  const { updateMessage } = useConversationQueryCache();
  const { messages } = useSlingApi();
  const { mapAPIMessageStrategy } = useConversationMappers();

  const mutation = useMutation({
    mutationFn: async (payload: UpdateMessagePayload) => {
      const result = await messages.update(payload);
      const message = mapAPIMessageStrategy(result.data);

      return message;
    },
    onSuccess: (message, payload) => {
      updateMessage(payload.conversationId, message);
    },
  });

  return mutation;
};
